<template lang="pug">
div.advancedSearch
  ods-form(
    :model='dataModel'
    :rules='searchRules'
    ref='advancedSearch'
    :show-message='true')
    ods-row(:gutter='24')
      ods-col(:span='6').flip
        ods-button(@click="toggleTemplatesDialog" type="text" :loading="loadingStaff.templates") {{ !dataModel.plantillasseleccionadas || !dataModel.plantillasseleccionadas.length ? $t('loyalty.select') : 'editar' }} {{ $t('loyalty.templates') }}
        br
        ods-tag(v-if="dataModel.plantillasseleccionadas && dataModel.plantillasseleccionadas[0]" closable type='default' @close="eliminarregistro(0)") {{ dataModel.plantillasseleccionadas[0].descripcion }}
        ods-tag(v-if="dataModel.plantillasseleccionadas && dataModel.plantillasseleccionadas[1]" closable type='default' @close="eliminarregistro(1)") {{ dataModel.plantillasseleccionadas[1].descripcion }}
        ods-popover(
          v-if="dataModel.plantillasseleccionadas && dataModel.plantillasseleccionadas.length > 2"
          ref='popoverTemplates'
          placement='top-start'
          trigger='hover'
          :title="dataModel.plantillasseleccionadas.length + ' ' + $t('loyalty.templates')")
          ul.no-bullets
            li(v-for="(plantilla, index) in dataModel.plantillasseleccionadas"
              :value="plantilla.descripcion"
              :key="plantilla.codigo")
              ods-tag(v-if="index > 1" closable type='default' @close="eliminarregistro(index)") {{ dataModel.plantillasseleccionadas[index].descripcion }}
        ods-tag(v-if="dataModel.plantillasseleccionadas && dataModel.plantillasseleccionadas.length > 2" type='default' v-popover:popoverTemplates='').pointer + {{ dataModel.plantillasseleccionadas.length - 2}}

      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.singlechannel')" prop="Channel" id="Channel")
          ods-select(v-model="dataModel.canaluso"
            :placeholder="loadingStaff.channels ? 'cagando' : !channelDropdown ? 'Sin datos' : 'Seleccionar'"
            :disabled="!channelDropdown")
              ods-option(label="Seleccionar" value="")
              ods-option(
                v-for="item in channelDropdown"
                :key="item.codcanal"
                :label="item.descanal"
                :value="item.codcanal")
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.Idtype')" prop="tipidcli")
          ods-select(v-model="dataModel.tipidcli"
            :placeholder="loadingStaff.ids ? 'cagando' : !idDropdown ? 'Sin datos' : 'Seleccionar'"
            :disabled="blockIds || !idDropdown")
            ods-option(label="Seleccionar" value="")
            ods-option(
              v-for="item in idDropdown"
              :key="item.tipidcli"
              :label="item.desctidc"
              :value="item.tipidcli")
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.identifier')" prop="idclient")
          ods-input(v-model="dataModel.idclient" :maxlength="20" :max="20" :disabled="blockIds")

    ods-row(:gutter='32')
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.name')" prop="nombreid")
          ods-input(v-model="dataModel.nombreid" :maxlength="20" :max="20" :disabled="blockNames")
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.firstName')" prop="apellid1")
          ods-input(v-model="dataModel.apellid1" :maxlength="20" :max="20" :disabled="blockNames")
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.lastName')" prop="apellid2")
          ods-input(v-model="dataModel.apellid2" :maxlength="20" :max="20" :disabled="blockNames || !(dataModel.apellid1 && dataModel.nombreid)")
      ods-col(:span='6').actions
        ods-button(@click="limpiar" type="text" style='color: #DE2F2F') {{ $t('loyalty.clean')}}
        ods-button(@click="AplicarFiltros" type="primary") {{ $t('loyalty.apply') }}

  ods-dialog(
    :title="$t('loyalty.templates')"
    :visible.sync="dialogVisible"
    width='60%'
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true")
    ods-progress(
      :percentage="percentage"
      :stroke-width="1"
      color="#2e6c99"
      :show-text="false")
    ods-table(v-if="tableData"
      ref="multipleTable"
      style='width: 100%'
      size="medium"
      height="60vh"
      :data='tableData'
      :row-key="codplantilla"
      @selection-change='handleSelectionChange')
      ods-table-column(type='selection' :reserve-selection='true' :selectable='selectable' width='50')
      ods-table-column(prop='NOMBRE' :label="$t('loyalty.name')" align="left")
        template(slot-scope="scope")
          div {{ scope.row.descripcion }}
      ods-table-column(prop='FECINI' :label="$t('loyalty.startDate')" align="center")
        template(slot-scope="scope")
          div {{ scope.row.fechaici | formatDateLocale }}
      ods-table-column(prop='FECFIN' :label="$t('loyalty.endDate')" align="center")
        template(slot-scope="scope")
          div {{ scope.row.fechafin | formatDateLocale }}
      ods-table-column(prop='IMPMIN' :label="$t('loyalty.minimumAmount')" align="right")
        template(slot-scope="scope")
          div {{ scope.row.imp_minimo }}
      ods-table-column(prop='MAXCUP' :label="$t('loyalty.maxCoupon')" align="right")
        template(slot-scope="scope")
          div {{ scope.row.num_max_cup }}
      ods-table-column(prop='CUPONESASIG' :label="$t('loyalty.couponsAssigned')" align="right")
        template(slot-scope="scope")
          div {{ scope.row.num_cup_act }}
    div.footer
      paginator(v-if="tableData!==null"
        :isNextPage="indMasDatos"
        :currentPage="currentPage"
        @buttonPrevAction="getPrevPagePlantillas"
        @buttonNextAction="getNextPagePlantillas")
    span.dialog-footer(slot='footer')
      ods-button(type='text' @click= "cerrar" style='color: #DE2F2F') {{ $t('loyalty.clean') }}
      ods-button(@click="toggleTemplatesDialog") {{ $t('close') }}
</template>

<script>
import Paginator from '@/components/shared/Paginator'
import { mapActions, mapGetters } from 'vuex'
import { Validator } from '@/utils/Validator.js'

export default {
  name: 'AdvancedSearch',
  props: ['parametros'],
  data () {
    var validateText = (rule, value, callback) => {
      // console.log(`0 ${rule.field}: [${value}] obligado: [${rule.required}]`)
      setTimeout(() => {
        if (rule.field === 'Channel') {
          Validator.maritalStatus(rule, value, callback)
        } else if (rule.field === 'nombreid') {
          if (value) {
            this.blockIds = true
            Validator.names(rule, value, callback)
          } else {
            if (this.dataModel.apellid1) {
              callback(new Error(this.$t('loyalty.requireField')))
            } else {
              this.blockIds = false
              Validator.names(rule, value, callback)
            }
          }
        } else if (rule.field === 'apellid1') {
          if (value) {
            this.blockIds = true
            Validator.names(rule, value, callback)
          } else {
            if (this.dataModel.nombreid) {
              callback(new Error(this.$t('loyalty.requireField')))
            } else {
              this.blockIds = false
              Validator.names(rule, value, callback)
            }
          }
        } else if (rule.field === 'apellid2') {
          Validator.names(rule, value, callback)
        } else if (rule.field === 'idclient') {
          if (value) {
            this.blockNames = true
            Validator.docId(rule, value, callback)
          } else {
            if (this.dataModel.tipidcli) {
              callback(new Error(this.$t('loyalty.requireField')))
            } else {
              this.blockNames = false
              Validator.docId(rule, value, callback)
            }
          }
        } else if (rule.field === 'tipidcli') {
          if (value) {
            this.blockNames = true
            callback()
          } else {
            if (this.dataModel.idclient) {
              callback(new Error(this.$t('loyalty.requireField')))
            } else {
              this.blockNames = false
              callback()
            }
          }
        }
      }, 200)
    }
    return {
      loadingStaff: {
        templates: true,
        channels: true,
        ids: true
      },
      percentage: 0,
      idDropdown: null,
      channelDropdown: null,
      dataModel: {},
      plantillasseleccionadasTemp: [],
      tableData: null,
      currentPage: null,
      dialogVisible: false,
      indMasDatos: null,
      blockNames: false,
      blockIds: false,
      searchRules: {
        Channel: [{ required: false, validator: validateText }],
        nombreid: [{ required: false, validator: validateText }],
        apellid1: [{ required: false, validator: validateText }],
        apellid2: [{ required: false, validator: validateText }],
        tipidcli: [{ required: false, validator: validateText }],
        idclient: [{ required: false, validator: validateText }]
      }
    }
  },
  components: {
    Paginator
  },
  computed: {
    ...mapGetters({
      nombre: 'getNombre',
      apellid1: 'getApellid1',
      apellid2: 'getApellid2',
      canalusof: 'getCanal',
      idclient: 'getIdclient',
      tipidcli: 'getTipidcli'
    })
  },
  created () {
    // console.log('created AS')
    this.loadingStaff.ids = true
    this.loadingStaff.channels = true
    this.loadingStaff.templates = true
  },
  async mounted () {
    // console.log('mounted AS props: parametros', this.parametros)
    const responseIds = this.getIdDropdown()
    responseIds.then(respIds => {
      // console.log('respIds.registros', respIds.registros)
      this.idDropdown = Array.isArray(respIds.registros) ? respIds.registros : [respIds.registros]
      this.loadingStaff.ids = false
      const respChannels = this.getCanales({})
      respChannels.then(responseCanales => {
        // console.log('respChannels.registros', responseCanales.registros)
        this.channelDropdown = Array.isArray(responseCanales.registros) ? responseCanales.registros : [responseCanales.registros]
        this.loadingStaff.channels = false
        this.getDataPlantillas({ avanzar: false })
        this.dataModel = { ...this.parametros }
        // this.handleValidate('advancedSearch')
        this.loadingStaff.templates = false
      }).catch(error => {
        console.log('error channels', error)
        this.loadingStaff.channels = false
        this.getDataPlantillas({ avanzar: false })
        this.loadingStaff.templates = false
      })
    }).catch(error => {
      console.log('error ids', error)
      this.loadingStaff.ids = false
    })
  },
  methods: {
    ...mapActions(['getProgram', 'getCanales', 'getIdDropdown', 'getTemplates']),
    async handleValidate (formName) {
      // console.log('validate')
      this.$refs[formName].validate((valid) => {
        // console.log(valid)
        return valid
      })
    },
    codplantilla (row) {
      return row.cod_plantilla
    },
    toggleTemplatesDialog () {
      this.dialogVisible = !this.dialogVisible
      if (this.dialogVisible) {
        this.plantillasseleccionadasTemp = this.dataModel.plantillasseleccionadas
        /* this.$notify({
          title: `Originales ${this.dataModel.plantillasseleccionadas.length}`,
          type: 'succes',
          offset: 150,
          duration: 1500
        }) */
      }
    },
    cerrar () {
      /*
      this.$notify({
        title: `Originales ${this.dataModel.plantillasseleccionadas.length} y las temporales ${this.plantillasseleccionadasTemp.length}`,
        type: 'succes',
        offset: 150,
        duration: 1500
      })
      */
      this.dataModel.plantillasseleccionadas = []
      this.$refs.multipleTable.clearSelection()
      this.toggleTemplatesDialog()
    },
    handleSelectionChange (rows) {
      console.log('handleSelectionChange', rows)
      if (rows && rows.length < 6) {
        this.percentage = parseFloat((rows.length / 5 * 100).toFixed(2))
        this.dataModel.plantillasseleccionadas = rows
      } else if (rows.length > 5) {
        this.$refs.multipleTable.clearSelection()
        this.$notify({
          title: '5 plantillas máximo',
          type: 'error',
          offset: 150,
          duration: 3000
        })
      }
    },
    selectable (row) {
      if (this.dataModel.plantillasseleccionadas.some(e => e.cod_plantilla === row.cod_plantilla)) {
        return true
      } else {
        return this.dataModel.plantillasseleccionadas.length < 5
      }
    },
    eliminarregistro (index) {
      const nuevosplantillasseleccionadas = []
      for (let x = 0; x <= this.dataModel.plantillasseleccionadas.length - 1; x++) {
        if (x !== index) {
          nuevosplantillasseleccionadas.push(this.dataModel.plantillasseleccionadas[x])
        } else {
          // console.log(`Elimina la selección de la tabla ${this.dataModel.plantillasseleccionadas[index].descripcion}`)
          try {
            this.$refs.multipleTable.toggleRowSelection(this.dataModel.plantillasseleccionadas[x], false)
          } catch (error) {
            console.log('Elimina la selección de la tabla', error)
          }
        }
      }
      this.dataModel.plantillasseleccionadas = nuevosplantillasseleccionadas
    },
    async getDataPlantillas (params) {
      this.loadingStaff.templates = true
      const response = await this.getTemplates(params)
      if (response.registros && response.retorno !== 210) {
        this.tableData = Array.isArray(response.registros) ? response.registros : [response.registros]
      } else {
        this.tableData = null
      }
      this.loadingStaff.templates = false
      this.currentPage = response.pantPagina
      this.indMasDatos = response.indMasDatos
      this.paginationParams = {
        claveInicio: response.claveInicio,
        claveFin: response.claveFin
      }
    },
    getPrevPagePlantillas () {
      this.activePagination = true
      this.getDataPlantillas({ ...this.defaultParams, ...this.paginationParams, retroceder: true })
    },
    getNextPagePlantillas () {
      this.activePagination = true
      this.getDataPlantillas({ ...this.defaultParams, ...this.paginationParams, avanzar: true })
    },
    async AplicarFiltros () {
      // hacer mutation de las variables a llamar
      this.$store.commit('SET_TYPE_TIPDICLI', this.dataModel.tipidcli)
      this.$store.commit('SET_TYPE_IDECLIENT', this.dataModel.idclient)
      this.$store.commit('SET_TYPE_CANAL', this.dataModel.canaluso)
      this.$store.commit('SET_TYPE_NAME', this.dataModel.nombreid)
      this.$store.commit('SET_TYPE_APELLIDO1', this.dataModel.apellid1)
      this.$store.commit('SET_TYPE_APELLIDO2', this.dataModel.apellid2)
      if (this.dataModel.plantillasseleccionadas) {
        for (var b = 0; b < this.dataModel.plantillasseleccionadas.length - 1; b++) {
          this.$store.commit(`SET_TYPE_CODPLANTILLA${b + 1}`, this.dataModel.plantillasseleccionadas[b].cod_plantilla)
        }
      }
      var params = {
        nombreid: this.dataModel.nombreid ? this.dataModel.nombreid : '',
        apellid1: this.dataModel.apellid1 ? this.dataModel.apellid1 : '',
        apellid2: this.dataModel.apellid2 ? this.dataModel.apellid2 : '',
        canaluso: this.dataModel.canaluso ? this.dataModel.canaluso : '',
        idclient: this.dataModel.idclient ? this.dataModel.idclient : '',
        tipidcli: this.dataModel.tipidcli ? this.dataModel.tipidcli : '',
        plantillasseleccionadas: this.dataModel.plantillasseleccionadas
      }
      this.$refs.advancedSearch.validate((valid) => {
        if (valid) {
          this.$emit('apply-advanced-search', params)
        }
      })
    },
    limpiar () {
      this.dataModel = {}
      this.dataModel.plantillasseleccionadas = []
      // this.$emit('clean-advanced-search')
    }
  }
}
</script>

<style lang="scss" scoped>
.actions {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}
.advancedSearch {
  background-color: #F9F9FB;
  padding: 14px;
}
ul.no-bullets {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.pointer {
  cursor: pointer;
}
.flip {
  margin-top: -14px;
}
</style>
